import { Collections, Description, Restaurant } from '@mui/icons-material';
import { BrandKey } from '../../../../../../../../__generated__/queries-web';
import { MEDIA_TYPES_LABEL } from '../../../../../../../../components/MediaInput/MultimediaPlugin/types';
import { getBrandOptions } from '../../../../../../../../utils/brands';

export const getAllowedMedias = (brandKey: BrandKey) => {
  const { isRecipe } = getBrandOptions(brandKey);

  return [
    {
      Icon: Description,
      label: 'Article',
      type: MEDIA_TYPES_LABEL.ARTICLES,
    },
    ...(isRecipe
      ? [
          {
            Icon: Restaurant,
            label: 'Recette',
            type: MEDIA_TYPES_LABEL.RECIPES,
          },
        ]
      : []),
    {
      Icon: Collections,
      label: 'Diapo',
      type: MEDIA_TYPES_LABEL.SLIDESHOWS,
    },
  ];
};
